import { customElement } from 'lit/decorators.js';
import { KiMenu } from '@kisters/wiski-web/components';
import { Mix } from '@kisters/wiski-web/common';
import { html, css } from 'lit';

@customElement('ki-menu-hdoe')
export default class KiMenuHdoe extends Mix(KiMenu) {
  static styles = [
    KiMenu.styles,
    css`
      :host {
        display: flex;
        height: 100%;
        overflow: hidden;
        background: white;
      }
      div.menu-item,
      div.sub-menu-item {
        color: white;
      }
      ki-icon {
        fill: white;
        font-size: 1.3em;
      }
      .sub-menu-item {
        margin-top: -1px;
      }
      .menu-item.selected {
        color: var(--theme-color-primary, #1d1d1b);
      }
      .menu-item {
        display: flex;
        color: white;
        flex-direction: row;
        margin: 10px 5px;
        background: var(--theme-color-primary, #1d1d1b);
        border: 1px solid var(--theme-color-primary, #1d1d1b);
        align-items: center;
        flex: 1 1 0%;
        position: relative;
        justify-content: start;
        transition: all 0.3s ease 0s;
        min-width: 0%;
        max-height: 100px;
        max-width: 320px;
      }

      :host(.md-screen) {
        font-size: 0.9em;
      }

      :host(.md-screen) .menu-icon {
        display: none;
      }

      :host(.md-screen) .menu-label {
        padding: 0px 1px;
      }
    `,
  ];

  render() {
    const isMobile = this.direction === 'vertical';
    this.classList.toggle('vertical', this.direction === 'vertical');
    return html`${this.items.map((item, index) => {
      const renderSubMenu = this.value === item;
      const hasSubMenu = item.items?.length > 0;
      return html`<div
          tabindex="0"
          title="${item.label}"
          class="menu-item ${item === this.value ? 'selected' : ''}"
          @keydown="${this.keydownevent}"
          @focusin="${isMobile ? null : this.handleOver}"
          @click="${this.handleOver}"
          @mouseleave="${isMobile ? null : this.handleLeave}"
          @focusout="${isMobile ? null : this.handleLeave}"
          @mouseenter="${isMobile ? null : this.handleOver}"
          .value="${item}"
          id="menu-item-${index}"
        >
          <div part="menu-icon" class="menu-icon">
            <ki-icon icon="${item.icon}"></ki-icon>
          </div>
          <div part="menu-label" class="menu-label">${item.label}</div>
          <div class="expand-icon ${hasSubMenu ? '' : 'hidden'}">
            <ki-icon
              icon="ki ${this.value && this.value === item
                ? 'ki-chevron-up'
                : 'ki-chevron-down'}"
            ></ki-icon>
          </div>
        </div>
        ${renderSubMenu ? this._renderSubMenu() : ''} `;
    })}`;
  }

  _renderSubMenu() {
    const isMobile = this.direction === 'vertical';
    const curentIndex = this.items.indexOf(this.value);
    const currentMenuItem = this.renderRoot.getElementById(
      `menu-item-${curentIndex}`,
    );
    const { height, top, left, width } =
      currentMenuItem.getBoundingClientRect(); // sub menu left position
    return html`<div
      class="sub-menu-wrapper ${this.direction === 'vertical'
        ? ''
        : 'horizontal'}"
      style="min-width:${width}px;left:${left}px;top:${top + height}px"
    >
      ${this.value?.items?.map(
        (subItem, i) =>
          html`<div
            class="sub-menu-item"
            title="${subItem.label}"
            tabindex="-1"
            id="menu-item-${curentIndex}-${i}"
            @keydown="${this.keydownevent}"
            @click="${this.handleClick}"
            .value="${subItem}"
            @mouseleave="${isMobile ? null : this.handleLeave}"
          >
            <div class="menu-icon">
              <ki-icon icon="${subItem.icon}"></ki-icon>
            </div>
            <div part="menu-label" class="menu-label">${subItem.label}</div>
          </div>`,
      )}
    </div>`;
  }

  // eslint-disable-next-line class-methods-use-this
  _getPrev(node) {
    node.classList.remove('focused');
    let next = node.previousElementSibling;
    if (next && next.classList.contains('sub-menu-wrapper')) {
      next = node.nextElementSibling.firstElementChild;
    }
    next.classList.add('focused');
    return next;
  }

  // eslint-disable-next-line class-methods-use-this
  _getNext(node) {
    node.classList.remove('focused');
    let next = node.nextElementSibling;
    if (next && next.classList.contains('sub-menu-wrapper')) {
      next = node.nextElementSibling.firstElementChild;
    }
    next.classList.add('focused');
    return next;
  }

  keydownevent(e) {
    switch (e.key) {
      case 'Enter':
        e.target.dispatchEvent(new CustomEvent('click'));
        break;
      case 'ArrowUp':
        this._getPrev(e.target).focus();
        break;
      case 'ArrowDown':
        this._getNext(e.target).focus();
        break;
      default:
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleLeave(e) {
    e.stopPropagation();
    const target = e.toElement || e.relatedTarget;
    if (!target) {
      return;
    }
    if (!target.classList.contains('sub-menu-item')) {
      this.value = null;
      this.requestUpdate();
    }
  }

  handleOver(e) {
    e.stopPropagation();
    if (e.currentTarget.value?.items) {
      if (this.value === e.currentTarget.value) {
        this.value = null;
      } else {
        this.value = e.currentTarget.value;
      }
      this.requestUpdate();
    }
  }
}
